// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-labelRight {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
  display: block;
  position: relative;
  left: -4%;
  margin: auto;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  height: 28px;
  width: 4px;
  clear: both;
  font-weight: normal;
  font-family: "Ruda", sans-serif;
  padding-right: 55px;
  margin-right: 40px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding-top: 4px;
  padding-left: 18px;
  border: 1px solid #adadad;
  margin-left: 300px;
}

.checkbox-labelRight input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-labelRight .mark {
  top: -1px;
  left: -36px;
  position: absolute;
  height: 34px;
  width: 44px;
  background-color: red;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  transition: all 0.3s ease-in;
}
.checkbox-labelRight input:checked ~ .mark {
  background-color: red;
  transform: rotate(0deg) scale(1);
  opacity: 1;
}
.checkbox-labelRight .mark::after {
  position: absolute;
  content: "";
  border-radius: 5px;
}
.checkbox-labelRight input:checked ~ .mark::after {
  transform: rotate(45deg) scale(1);
  left: 17px;
  top: 4px;
  width: 8px;
  height: 16px;
  border: solid white;
  border-width: 0 4px 4px 0;
  border-radius: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubComponents/OptionsRight/optionsRight.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".checkbox-labelRight {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n  display: block;\n  position: relative;\n  left: -4%;\n  margin: auto;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 24px;\n  height: 28px;\n  width: 4px;\n  clear: both;\n  font-weight: normal;\n  font-family: \"Ruda\", sans-serif;\n  padding-right: 55px;\n  margin-right: 40px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding-top: 4px;\n  padding-left: 18px;\n  border: 1px solid #adadad;\n  margin-left: 300px;\n}\n\n.checkbox-labelRight input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkbox-labelRight .mark {\n  top: -1px;\n  left: -36px;\n  position: absolute;\n  height: 34px;\n  width: 44px;\n  background-color: red;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  transition: all 0.3s ease-in;\n}\n.checkbox-labelRight input:checked ~ .mark {\n  background-color: red;\n  transform: rotate(0deg) scale(1);\n  opacity: 1;\n}\n.checkbox-labelRight .mark::after {\n  position: absolute;\n  content: \"\";\n  border-radius: 5px;\n}\n.checkbox-labelRight input:checked ~ .mark::after {\n  transform: rotate(45deg) scale(1);\n  left: 17px;\n  top: 4px;\n  width: 8px;\n  height: 16px;\n  border: solid white;\n  border-width: 0 4px 4px 0;\n  border-radius: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
